import { render, staticRenderFns } from "./ContentHeader.vue?vue&type=template&id=20c02946&scoped=true"
import script from "./ContentHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContentHeader.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ContentHeader.vue?vue&type=style&index=0&id=20c02946&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c02946",
  null
  
)

export default component.exports